import React from 'react';
import { Text } from '../../../../components/Typography/Typography';
import BenchmarkQuestionCard from './BenchmarkQuestionCard';
import { BenchmarkQuestion } from '../../../../store/benchmark/types';
import styles from '../BenchmarkQuestionsPage.module.scss';

interface BenchmarkGridProps {
  questions: BenchmarkQuestion[];
  onEdit: (question: BenchmarkQuestion) => void;
  onDelete: (question: BenchmarkQuestion) => void;
}

const BenchmarkGrid: React.FC<BenchmarkGridProps> = ({ questions, onEdit, onDelete }) => {
  if (questions.length === 0) {
    return (
      <div className={styles.noResults}>
        <Text color="neutral-600" align="center">
          No benchmark questions found
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {questions.map((question) => (
        <BenchmarkQuestionCard
          key={question.id}
          question={question}
          onEdit={() => onEdit(question)}
          onDelete={() => onDelete(question)}
        />
      ))}
    </div>
  );
};

export default BenchmarkGrid;
